export { default } from './MenuPopoverCDS';
